import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.css';
import '../DateRangePicker.css';
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./SearchForm.css";


const statusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "pending", label: "Pending" },
  { value: "completed", label: "Completed" },
];

const DateFilterModule = () => {
  const { register, handleSubmit, control } = useForm();
  const [selectedDate_start, setSelectedDate_start] = useState("");
  const [selectedDate_end, setSelectedDate_end] = useState("");

  const onSubmit = (data) => {
    console.log("Submitted values:", {
      ...data,
      status: data.status?.map((opt) => opt.value),
      dateRange: selectedDate_start && selectedDate_end
        ? `${selectedDate_start} - ${selectedDate_end}`
        : "",
    });
  };

  return (
    <form className="filter-form" onSubmit={handleSubmit(onSubmit)}>
      {/* Date Range Picker */}
      <DateRangePicker
        initialSettings={{
          autoUpdateInput: false,
          locale: {
            cancelLabel: "Clear",
            format: "YYYY-MM-DD",
          },
        }}
        onApply={(event, picker) => {
          setSelectedDate_start(picker.startDate.format("YYYY-MM-DD"));
          setSelectedDate_end(picker.endDate.format("YYYY-MM-DD"));
        }}
        onCancel={() => {
          setSelectedDate_start("");
          setSelectedDate_end("");
        }}
      >
        <input
          type="text"
          className="form-control pb-filter-input"
          value={
            selectedDate_start && selectedDate_end
              ? `${selectedDate_start} - ${selectedDate_end}`
              : ""
          }
          placeholder="Date Range"
          onChange={(e) => {
            const dates = e.target.value.split("-");
            setSelectedDate_start(dates[0]?.trim() || "");
            setSelectedDate_end(dates[1]?.trim() || "");
          }}
        />
      </DateRangePicker>

      {/* React-Select Status Dropdown */}
      <Controller
        name="status"
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            options={statusOptions}
            isMulti
            className="react-select-container  pb-filter-input"
            classNamePrefix="react-select"
            placeholder="Select Status"
          />
        )}
      />

      {/* Open-end Search Field */}
      <input
        type="text"
        placeholder="Search..."
        className="form-control  pb-filter-input"
        {...register("searchText")}
      />

      {/* Submit Button */}
      <button type="submit" className="btn btn-filter">
        Submit
      </button>
    </form>
  );
};

export default DateFilterModule;
